import request from "@/utils/request";
// 专家评分

//根据当前登录人获取专家评分项目列表
export const getExpertScoreProjectList = (data) => {
  return request({
    url: "/api/eduExpertsScore/projectList",
    method: "post",
    data
  });
};
//根据当前登录人获取评审课题
export const getExpertScoreAuditList = (data) => {
  return request({
    url: "/api/eduExpertsScore/auditList",
    method: "post",
    data
  });
};
//保存或者修改专家评分
export const saveOrUpdateExpertsScore = (data) => {
  return request({
    url: "/api/eduExpertsScore/saveOrUpdateExpertsScore",
    method: "post",
    data
  });
};
//通过课程id,设置id,和评分id查看专家课程详情
export const getDeclareInfoByGroupIdAndDeclareId = (data) => {
  return request({
    url: `/api/eduExpertsScore/getDeclareInfoByGroupIdAndDeclareId/${data.groupId}/${data.declareId}/${data.expertsScoreId}`,
    method: "get",
  });
};
//专家提交评审
export const submitExpertReview = (id) => {
  return request({
    url: `/api/eduExpertsScore/submitExpertsReview/${id}`,
    method: "get",
  });
};

//专家提交评审
export const submitExpertReviewNew = (id) => {
  return request({
    url: `/api/eduManagementExpertsScore/submitExpertsReview/${id}`,
    method: "get",
  });
};


//通过项目id来查看当前登录人是否有初评复评终评资格
export const getProjectIdByQualification = (projectId) => {
  return request({
    url: `/api/eduExpertsScore/getProjectIdByQualification/${projectId}`,
    method: "get",
  });
};

//获取当前登录人专家评审最新时间的项目id
export const getLastestProjectToReview = () => {
  return request({
    url: `/api/eduExpertsScore/getNewTimeProject`,
    method: "get",
  });
};


//文件下载
export const downloadFile = (data) =>{
  return request({
    url:'/upload/download?id='+data.id+"&openStyle="+data.openStyle,
    method:'get',
    responseType:'blob',
  })
}
